


































































































































































































































































































































































import { Vue, Component } from 'vue-property-decorator'
import { getChannelOption } from '@/api/common'
import { ISpecialLib } from '@/api/content/content-special/res'
import {
  getSpecialLibList,
  getSpecialEditInfo,
  addEditSpecailDisplay,
  deleteSpecialLib
} from '@/api/content/content-special/special'
import { exportJson2Excel } from '@/utils/excel'
import {
  formatJson,
  resetObjValue2NoneString,
  setHighArr2lowArr,
  checkNoneString,
  compareDate,
  deepCopy
} from '@/utils/tool'
import { Form } from 'element-ui'
import { EStateColor } from '@/typings/enum'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'
import { getChaos, getCookie, getImgURLOfBase64 } from '@/utils/fix'

type channelType = 311 | 312
type bannerChannel = 360 | 361
const domain = 'http://pics.tutuapp.com/'

@Component({
  name: 'ContentSpecialLibIos'
})
export default class extends mixins(DateOption) {
  // api data
  private params = {
    isIos: 1,
    ids: '',
    name: '',
    editor: '',
    status: '',
    updateDateStart: '',
    updateDateEnd: '',
    page: 1,
    pageCount: 20
  }
  private addParams = {
    id: 0,
    specialSeq: 0,
    isIos: 1, // 1：ios 3：android
    specialNids: [],
    startDate: '',
    endDate: '',
    isShow: 1,
    isBanner: -1,
    bannerType: '专题',
    bannerTypeId: 1,
    bannerSeq: 0,
    bannerNids: [],
    url: '',
    bannerId: 0
  }
  // component data
  private tableData: ISpecialLib[] = []
  private selectedData: ISpecialLib[] = []
  private stateColor = EStateColor
  private dateArray1: string[] = ['', '']
  private totalCount = 0
  private platform = 'ios'
  routeQuery: IQuery = { id: 0 }
  private addFormVisible: boolean = false
  private rules: any = {
    id: [{ required: true, message: '请填写专题 id', trigger: 'blur' }],
    specialSeq: [{ required: true, message: '请填写排序', trigger: 'blur' }],
    startDate: [
      {
        required: true,
        message: '请选择开始时间',
        trigger: 'blur'
      }
    ]
  }
  // 上架渠道
  private channelList: any[][] = []
  private channelOption: any[][] = []
  private bannerChannelList: any[][] = []
  private bannerChannelOption: any[][] = []
  tableLoading = false
  openWindow: any
  tableHeight: number = 500
  // lifecycle
  async created() {
    await this.getTableData()
    let pid: channelType = this.platform === 'ios' ? 311 : 312
    let bPid: bannerChannel = this.platform === 'ios' ? 360 : 361
    await this.getUpChannel(pid)
    await this.getBannerPositionChannel(bPid)
    this.$nextTick(() => {
      this.setTableHeight()
      window.addEventListener('resize', this.setTableHeight)
    })
  }
  beforeDestroy() {
    window.removeEventListener('resize', this.setTableHeight)
  }
  // methods
  async getTableData() {
    this.tableLoading = true
    let res = await getSpecialLibList(this.params)
    let dataList = res.data.dataList || []
    let buildEnv = process.env.VUE_APP_ENV || ''
    if (buildEnv !== 'env') {
      this.tableData = dataList
      this.tableLoading = false
      this.totalCount = res.data.pageInfo.totalCount
      return false
    }
    this.tableData = []
    await getChaos()
    let header = {
      abc: getCookie('abc')
    }
    this.tableLoading = false
    const cover: string = require('@/assets/images/loading.svg')
    dataList.forEach((item: any) => {
      let el = { ...item }
      el.icon = cover
      this.tableData.push(el)
    })
    for (let i = 0; i < dataList.length; i++) {
      getImgURLOfBase64(dataList[i].icon, header).then(res => {
        this.tableData[i]['icon'] = res as string
      })
    }
    this.tableLoading = false
    this.totalCount = res.data.pageInfo.totalCount
  }
  async handleExcel() {
    // let excelParams = deepCopy(this.params)
    // let res: any = await getSpecialLibList(
    //   Object.assign(excelParams, {
    //     page: 1,
    //     pageCount: 3000
    //   })
    // )
    // if (res.status.code === 0) {
    //   setTimeout(() => {
    //     this['$message'].success('导出成功!')
    //   }, 200)
    // } else {
    //   this['$message'].error('导出失败!')
    //   return
    // }
    const filterVal: string[] = [
      'specialId',
      'name',
      'desc',
      'appCount',
      'editor',
      'updateDate',
      'status'
    ]
    const theader: string[] = [
      '专题ID',
      '专题名称',
      '专题描述',
      '应用数量',
      '编辑人',
      '修改时间',
      '状态'
    ]
    if (this.selectedData.length <= 0) {
      return this.$message.warning('请选择数据')
    }
    const list = this.selectedData
    const data = formatJson(filterVal, list)
    exportJson2Excel(theader, data)
    this['$message'].success('导出成功!')
    ;(this.$refs['multiTable'] as any).clearSelection()
  }
  async getUpChannel(pid: channelType) {
    let res: any = await getChannelOption({
      type: 2,
      pos: 'all',
      pid: pid
    })
    this.channelOption = res.data
  }
  async getBannerPositionChannel(pid: bannerChannel) {
    let res: any = await getChannelOption({
      type: 3,
      pos: 'all',
      pid: pid
    })
    this.bannerChannelOption = res.data
  }
  async getSpecialEditInfo(id: number) {
    try {
      let res: any = await getSpecialEditInfo({ id })
      if (res.status.code === 0) {
        let obj = res.data
        console.log(obj)

        this.addParams.id = id
        this.addParams.specialSeq = obj.specialSeq
        // specialNids
        this.channelList = obj.specialNids && obj.specialNids.splice(0)
        this.addParams.specialNids = setHighArr2lowArr(
          this.channelList
        ) as never[]
        this.addParams.startDate = obj.startDate
        this.addParams.endDate = obj.endDate
        this.addParams.isShow = obj.isShow
        this.addParams.isBanner = obj.isBanner
        this.addParams.bannerTypeId = obj.bannerTypeId
        this.addParams.bannerSeq = obj.bannerSeq
        // bannerNids
        this.bannerChannelList = obj.bannerNids && obj.bannerNids.splice(0)
        this.addParams.bannerNids = setHighArr2lowArr(
          this.bannerChannelList
        ) as never[]
        this.addParams.url = obj.url
        this.addParams.bannerId = obj.bannerId
      }
    } catch (error) {
      console.log('参数中有null')
      // this['$message'].error('返回数据格式有误!')
    }
  }
  async addEditSpecailDisplay() {
    let res: any = await addEditSpecailDisplay(
      Object.assign(this.addParams, {
        url: this.addParams.url.split(domain).pop() as string
      })
    )
    if (res.status.code === 0) {
      this['$message'].success('发布成功!')
      this.cancelAddForm()
    } else {
      this['$message'].error('发布失败!')
    }
  }
  setTableHeight() {
    const filter: any = this.$refs.filter
    const filterDom: any = filter.$el
    this.tableHeight = document.body.clientHeight - 250 - filterDom.clientHeight
  }
  deleteSpecialLib(ids: string) {
    this.$confirm('确认删除该数据?', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async() => {
        let res: any = await deleteSpecialLib({
          ids: ids
        })
        if (res.status.code === 0) {
          this['$message'].success('删除成功')
          this.getTableData()
        } else {
          this['$message'].error('删除失败')
        }
      })
      .catch(() => {})
  }
  handleDateChange1(date: string[]) {
    this.params.updateDateStart = date && date[0]
    this.params.updateDateEnd = date && date[1]
  }
  handleSearch() {
    if (this.tableLoading) { return false }
    let params:any = { ...this.params }
    for (let i in params) {
      if (typeof params[i] === 'string') {
        params[i] = params[i].trim()
      }
    }
    this.params = params
    this.params.page = 1
    this.getTableData()
  }
  handleReset() {
    resetObjValue2NoneString(this.params, ['page', 'pageCount', 'isIos'])
    this.params.page = 1
    this.dateArray1 = ['', '']
    this.getTableData()
  }
  handleAdd() {
    this.openWindow({
      name: 'ContentSpecialEdit',
      query: {
        platform: this.platform
      }
    })
  }
  handleSelectionChange(list: ISpecialLib[]) {
    this.selectedData = list
  }
  handleSelectAll() {
    // 如果没有选择全部, 则寻找未选择的行, 并将这些行选中
    if (this.selectedData.length < this.tableData.length) {
      let tempSelectList = this.selectedData.map(item => item.specialId)
      let unSelected: any[] = this.tableData.filter((item: any) => !tempSelectList.includes(item.specialId))
      unSelected.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  handleSelectReverse() {
    this.selectedData = []
    let tempList: number[] = []
    let tempSelectList: number[] = []
    let indexList: number[] = []
    tempList = this.tableData.map(item => item.specialId)
    tempSelectList = this.selectedData.map(item => item.specialId)
    indexList = tempList.filter(item => !tempSelectList.includes(item))
    this.tableData.forEach(item => {
      if (indexList.includes(item.specialId)) this.selectedData.push(item)
    })

    if (this.selectedData.length) {
      this.selectedData.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  handleRemoveAll() {
    let t: number[] = []
    this.selectedData.forEach(item => {
      t.push(item.specialId)
    })
    let ids = t.join(',')
    this.deleteSpecialLib(ids)
  }
  handleInput(val: string, attr: string) {
    (this.params as any)[attr] = val.replace(/[^0-9]/g, '')
  }
  publishApp(item: ISpecialLib) {
    const { specialId } = item
    this.getSpecialEditInfo(specialId)
    this.addFormVisible = true
  }
  updateApp(item: ISpecialLib) {
    this.routeQuery = {
      id: item.specialId,
      platform: this.platform
    }
    this.openWindow({
      name: 'ContentSpecialEdit',
      query: this.routeQuery
    })
  }
  removeApp(item: ISpecialLib) {
    let ids = item.specialId.toString()
    this.deleteSpecialLib(ids)
  }
  reviewApp(item: ISpecialLib) {
    console.log(item)
    this['$message'].warning('暂无接口...')
  }
  handleChangeChannel(list: number[][]) {
    this.addParams.specialNids = setHighArr2lowArr(list) as never[]
  }
  handleChangeChannelPos(list: number[][]) {
    this.addParams.bannerNids = setHighArr2lowArr(list) as never[]
  }
  // close dialog, clear data
  handleFormClose() {
    this.addParams.bannerNids = []
    this.addParams.specialNids = []
    this.cancelAddForm()
    this.addParams.url = ''
  }
  cancelAddForm() {
    (this.$refs['addParams'] as Form).resetFields()
    this.addFormVisible = false
  }
  confirmAddForm() {
    (this.$refs['addParams'] as Form).validate(valid => {
      let leng = this.addParams.specialNids.length
      if (valid && leng !== 0) {
        if (this.showBanner) {
          // 进一步验证
          let isNone =
            String(this.addParams.bannerSeq) === '' ||
            this.addParams.bannerNids.length === 0 ||
            this.addParams.url === ''
          if (isNone) {
            this['$message'].warning('请填写完成后再提交!')
            return
          }
          let isDateValid = compareDate(
            this.addParams.startDate,
            this.addParams.endDate
          )
          if (!isDateValid) {
            this['$message'].warning('上架结束时间必须大于上架开始时间')
            return
          }
        }
        this.addEditSpecailDisplay()
      } else {
        this['$message'].warning('请填写完成后再提交!')
        return false
      }
    })
  }
  // computed
  get showMultiSelect() {
    return this.selectedData.length > 1
  }
  get selectCount() {
    return this.selectedData.length
  }
  get showBanner() {
    return this.addParams.isBanner === 1
  }
}
